<template>
  <div>
    <div
      v-if="isEditing"
      class="editor-heading">

      <input-text
        variant="standardInput"
        inputName="from"
        inputLabel="From:"
        inputPlaceholder="From"
        :inputValue="getEditedParts.from"
        @fieldUpdate="updateContentField" />

      <input-tags
        variant="standardInput"
        inputName="to"
        inputLabel="To:"
        inputPlaceholder="To"
        :inputValue="getEditedParts.to"
        @fieldUpdate="updateContentField" />

      <input-tags
        variant="standardInput"
        inputName="cc"
        inputLabel="Cc:"
        inputPlaceholder="Cc"
        :inputValue="getEditedParts.cc"
        @fieldUpdate="updateContentField" />

      <input-tags
        variant="standardInput"
        inputName="bcc"
        inputLabel="Bcc:"
        inputPlaceholder="Bcc"
        :inputValue="getEditedParts.bcc"
        @fieldUpdate="updateContentField" />

      <input-text
        variant="standardInput"
        inputName="subject"
        inputLabel="Subject:"
        inputPlaceholder="Subject"
        :inputValue="getEditedParts.subject"
        @fieldUpdate="updateContentField" />

      <input-textarea
        variant="standardInput"
        inputName="text"
        inputLabel="Text:"
        inputPlaceholder="Text"
        :inputValue="getEditedParts.text"
        @fieldUpdate="updateContentField" />

      <input-textarea
        variant="standardInput"
        inputName="html"
        inputLabel="Html:"
        inputPlaceholder="Html"
        :inputValue="getEditedParts.html"
        @fieldUpdate="updateContentField" />

      <div class="text-center">
        <input-button
          variant="standardInput"
          btnStyle="ok-style"
          :inputPlaceholder="$t('Button.save')"
          smaller
          boxy
          @click="updateContent()" />

        <input-button
          variant="standardInput"
          btnStyle="default-style"
          :inputPlaceholder="$t('Button.cancel')"
          smaller
          boxy
          @click="toggleEditContent(false)" />

      </div>
    </div>
    <div v-else>
      <button
        class="mb-2"
        @click="toggleEditContent(true)">

        <icon name="pencil" />
      </button>

      <component
        :is="p.tag"
        v-for="p in displayParts"
        :key="p.name"
        class="content-line">

        {{ getEditedParts[p.name] }}
      </component>
    </div>
  </div>
</template>

<script>
import InputText from '@/components/standard/input/InputText'
import InputButton from '@/components/standard/input/InputButton'
import InputTextarea from '@/components/standard/input/InputTextarea'
import InputTags from '@/components/standard/input/InputTags'
import contentEditor from '@/mixins/service/administration/contentEditor'

export default {
  components: {
    'input-text': InputText,
    'input-button': InputButton,
    'input-textarea': InputTextarea,
    'input-tags': InputTags
  },

  mixins: [
    contentEditor
  ]
}
</script>

<style scoped>
button {
  background-color: transparent;
  border: none;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/service/administration/editor/EmailEditor.vue?f264a622